<template>
  <v-btn
    class="primary-button"
    :loading="loading"
    :disabled="disabled"
    @click="$emit('click')"
  >
    {{ text }}
    <v-icon
      v-if="hasWarnings"
      right
      dark
      color="yellow"
    >
      mdi-alert
    </v-icon>
    <v-icon
      v-if="!hasWarnings"
      right
      dark
      color="#fff"
    >
      mdi-check-circle
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    hasWarnings: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "Зберегти",
    },
  },

};
</script>